'use strict';
exports.STORE = {
    magic: "\x00\x00",
    compress: function(content, compressionOptions) {
        return content; // no compression
    },
    uncompress: function(content) {
        return content; // no compression
    },
    compressInputType: null,
    uncompressInputType: null
};
exports.DEFLATE = require('./flate');



//////////////////
// WEBPACK FOOTER
// /~/jszip/lib/compressions.js
// module id = 623
// module chunks = 0